import React, { createContext, useContext } from 'react';
import { CONTACT_INFO } from '../mock';

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  // All "Book now" CTAs open the clinic's Mangomint booking page in a new tab.
  const openBooking = () => {
    window.open(
      CONTACT_INFO.bookingUrl || 'https://booking.mangomint.com/589210',
      '_blank',
      'noopener,noreferrer'
    );
  };

  // Kept for API compatibility with the old in-page modal (no-op now).
  const closeBooking = () => {};

  return (
    <BookingContext.Provider
      value={{ isOpen: false, openBooking, closeBooking, preselectedService: null }}
    >
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error('useBooking must be used within BookingProvider');
  return ctx;
};
